import React, { useEffect, useState } from 'react';
import styles from './LoadingDots.module.scss';

export default function LoadingDots(): React.ReactElement {
  const [message, setMessage] = useState('');

  useEffect(() => {
    const firstTimer = setTimeout(() => {
      setMessage('Still working...');
    }, 20000);

    const secondTimer = setTimeout(() => {
      setMessage('Almost there...');
    }, 40000);

    return () => {
      clearTimeout(firstTimer);
      clearTimeout(secondTimer);
    };
  }, []);

  return (
    <div className={styles.body}>
      <div className={styles.dots}>
        <div className={styles.dot} />
        <div className={styles.dot} />
        <div className={styles.dot} />
      </div>
      <div className={styles.message}>{message}</div>
    </div>
  );
}
